import { Injectable } from '@angular/core';
import { createEffect, ofType } from '@ngrx/effects';
import { map, tap } from 'rxjs/operators';

import { OWCC_LOCAL_STORAGE_KEY } from 'src/app/core/config/web-storage.config';
import { LocalStorageService } from 'src/app/core/services/storage/local-storage/local-storage.service';

import { EffectsBase } from '../effects-base';

import { UserConfigActionType } from './user-config.actions';

@Injectable()
export class UserConfigEffects extends EffectsBase {
  public updatePostalCode$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(UserConfigActionType.UpdatePostalCode),
        map((payload: { postalCode: string | undefined }) => payload.postalCode),
        tap(postalCode => {
          if (postalCode) {
            this.localStorageService.set(OWCC_LOCAL_STORAGE_KEY.POSTAL_CODE, postalCode);
          } else {
            this.localStorageService.delete(OWCC_LOCAL_STORAGE_KEY.POSTAL_CODE);
          }
        })
      ),
    { dispatch: false }
  );

  public constructor(private readonly localStorageService: LocalStorageService) {
    super();
  }
}
